import React, { useState, useEffect } from 'react';
import api from "../../utils/apiClient";
import Navbar from '../Navbar';
import Foooter from '../Foooter';
import '../../style/ContentView.css';
import FooterMovil from '../FooterMovil';

function AboutUs() {
    const [content, setContent] = useState('');

    useEffect(() => {
        fetchContent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchContent = async () => {
        try {
            const response = await api.get("content/content/Nosotros");
            setContent(response.data.body);
        } catch (error) {
            console.error("Error fetching content:", error);
        }
    };

    return (
        <>
        <Navbar/>
        <div className="content-container">
            <div className="content-body-a">
                <h1>Sobre Nosotros</h1>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        </div>
        <div className="footer">
        <Foooter/>
        </div>
        <div className="footer-movil">
        <FooterMovil/>  
        </div>
        </>
    );
}

export default AboutUs;
